import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Chart, registerables} from "chart.js";
import {plano} from "../../../models/plano";
import {zona} from "../../../models/zona";
import {sensor} from "../../../models/sensor";
import {Localiser} from "../../../services/localiser";
import {UserService} from "../../../services/user.service";
import {Navigation} from "../../../services/navigation.service";
import {ProyectoService} from "../../../services/proyecto.service";
import {PlanoService} from "../../../services/plano.service";
import {ZonaService} from "../../../services/zona.service";
import {AlertaService} from "../../../services/alerta.service";
import {SensorService} from "../../../services/sensor.service";
import {sensorDataChart} from "../../../models/sensorDataChart";

@Component({
  selector: 'app-indicators-sensors',
  templateUrl: './indicators-sensors.component.html',
  styleUrls: ['./indicators-sensors.component.css']
})
export class IndicatorsSensorsComponent implements OnInit {

  sensores: Array<sensor> = [];
  sensoresFiltro: Array<sensor> = [];
  sensoresReal: Array<sensor> = [];
  sensorDataRequest = undefined;
  sensorData: Array<sensorDataChart> = undefined;

  planos: Array<plano>;
  zonas: Array<zona>;
  showZonas = [];
  planoSelected: plano;
  zonaSelected: zona;
  searcherLuminarias: string = "";
  intervalDefault: number = 100;
  intervalMax: number = 1000;
  interval: number = this.intervalDefault;
  moreThanDay: boolean = false;
  startCustomTime: undefined;
  endCustomTime: undefined;

  loading: boolean = false;
  selectedSensor: sensor = undefined;
  sensorsFilterTime = 1;
  sensoresChart: Chart;

  labels = [];

  constructor(public localiser: Localiser, public user: UserService, private navigation: Navigation,
              public proyectoService: ProyectoService, private planoService: PlanoService,
              private zonaService: ZonaService, private alertaService: AlertaService,
              private sensorService: SensorService, private  changeDetectorRef: ChangeDetectorRef) {
    Chart.register(...registerables);
  }

  ngOnInit(): void {
    this.getSensores();
    this.getPlanos();
    this.getZonas();
    this.sensorsChart();
  }

  getSensores() {
    this.sensorService.getSensores420ByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((response: Array<sensor>) => {
        this.sensoresReal = response;
        this.sensoresFiltro = this.sensoresReal;
        this.sensores = this.sensoresFiltro;
        if (this.sensores.length > 0) {
          this.selectedSensor = this.sensores[0];
          this.getSensorData();
        }
    });
  }

  getSensorData() {
    this.loading = true;

    // Cancel any previous unfinished request
    if (this.sensorDataRequest != undefined) {
      this.sensorDataRequest.unsubscribe();
      this.sensorData = undefined;
    }

    let timestamps = this.getTimestamps();
    if (timestamps != undefined) {
      this.sensorService.getSensorDataByTimestamps(this.selectedSensor.idLuminaria, timestamps.init, timestamps.end, this.interval).subscribe((result: Array<sensorDataChart>) => {
        this.loading = false;
        this.sensorData = result;
        this.setSensorData();
      })
    }
  }

  getTimestamps() {
    if (this.sensorsFilterTime == 1) {
      return this.getTimestampsToday();
    } else if (this.sensorsFilterTime == 2) {
      return this.getTimestampsYesterday();
    } else if (this.sensorsFilterTime == 3) {
      return this.getTimestampsWeek();
    } else if (this.sensorsFilterTime == 4) {
      return this.getTimestampsMonth();
    } else if (this.sensorsFilterTime == 5) {
      return this.getTimestampsYear();
    } else if (this.sensorsFilterTime == 6) {
      return this.getTimestampsCustom();
    } else {
      return undefined;
    }
  }

  getTimestampsToday() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    return {"init": today.getTime(), "end": new Date().getTime()};
  }

  getTimestampsYesterday() {
    let yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    return {"init": yesterday.getTime(), "end": today.getTime()};
  }

  getTimestampsWeek() {
    let week = new Date();
    week.setDate(week.getDate() - 6);
    week.setHours(0, 0, 0, 0);
    return {"init": week.getTime(), "end": new Date().getTime()};
  }

  getTimestampsMonth() {
    let week = new Date();
    week.setDate(week.getDate() - 30);
    week.setHours(0, 0, 0, 0);
    return {"init": week.getTime(), "end": new Date().getTime()};
  }

  getTimestampsYear() {
    let week = new Date();
    week.setDate(week.getDate() - 365);
    week.setHours(0, 0, 0, 0);
    return {"init": week.getTime(), "end": new Date().getTime()};
  }

  getTimestampsCustom() {
    return {"init": new Date(this.startCustomTime).getTime(), "end": new Date(this.endCustomTime).getTime()};
  }

  getPlanos() {
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<plano>) => {
      this.planos = result;
    })
  }

  getZonas() {
    this.zonaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<zona>) => {
      this.zonas = result;
    })
  }

  selectPlano(planoEv) {
    if (planoEv == -1) {
      this.planoSelected = undefined;
      this.zonaSelected = undefined;
      this.sensoresFiltro = this.sensoresReal;
      this.sensores = this.sensoresFiltro;
      this.searcherLuminariasFunc();
    } else {
      this.planoSelected = this.planos.find(plano => plano.idPlano == planoEv.idPlano);
      this.zonaSelected = undefined;
      this.showZonas = this.zonas.filter(zona => {
        return zona.idPlano == this.planoSelected.idPlano;
      });
      this.sensoresFiltro = this.sensoresReal.filter(sensor => sensor.idPlano == planoEv.idPlano);
      this.sensores = this.sensoresFiltro;
      this.searcherLuminariasFunc();
    }
  }

  selectZona(zonaEv) {
    if (zonaEv == -1) {
      this.zonaSelected = undefined;
      this.selectPlano(this.planoSelected)
    } else {
      this.zonaSelected = this.showZonas.find(zona => zona.id == zonaEv.id);
      this.sensoresFiltro = this.sensoresReal.filter(sensor => sensor.idZona == zonaEv.id);
      this.sensores = this.sensoresFiltro;
      this.searcherLuminariasFunc();
    }
  }

  searcherLuminariasFunc() {
    this.sensores = this.sensoresFiltro.filter(sensor =>
      (sensor.nombre.toLowerCase().includes(this.searcherLuminarias.toLowerCase())) ||
      (sensor.idLuminaria.toLowerCase().includes(this.searcherLuminarias.toLowerCase())));
    if (!this.sensores.includes(this.selectedSensor) && this.sensores.length > 0) {
      this.selectedSensor = this.sensores[0];
      this.getSensorData();
    }
  }

  setSensorData() {
    let labels = [];
    let data = [];
    let upperThreshold = [];
    let lowerThreshold = [];

    // Revisar la diferencia de tiempo entre dos medidas
    this.moreThanDay = false;
    if (this.sensorData.length > 1) {
      if (this.sensorData[1].stamp_t - this.sensorData[0].stamp_t > 86400) {
        this.moreThanDay = true;
      }
    }


    for (let i = 0; i < this.sensorData.length; i++) {
      labels.push(this.sensorData[i].stamp_t)// this.convertTimestampToLabel(this.sensorData[i].stamp_t, moreThanDay))
      data.push(this.measureToData(this.sensorData[i]));
      upperThreshold.push(this.sensorData[i].umbralAlto);
      lowerThreshold.push(this.sensorData[i].umbralBajo);
    }
    this.labels = labels;
    this.changeSensoresChart(labels, data, upperThreshold, lowerThreshold);
  }

  convertTimestampToLabel(timestamp) {
    let date: Date = new Date(timestamp * 1000);

    // Si hay mas de un día de diferencia mostrar solo día/mes
    if (this.moreThanDay) {
      return date.getDate() + "/" + (date.getMonth() + 1);

      // Si hay menos de un día de diferencia mostrar día/mes - hora:minuto
    } else {
      let minutes = date.getMinutes().toString();
      if (minutes.length == 1) {
        minutes = "0" + minutes;
      }
      return date.getDate() + "/" + (date.getMonth() + 1) + " - " + date.getHours() + ":" + minutes;
    }
  }

  changeSensoresChart(labels, data, upperThreshold, lowerThreshold) {
    this.sensoresChart.data = {
      labels: labels,
      datasets: [{
        type: 'line',
        label: 'Upper Threshold',
        data: upperThreshold,
        backgroundColor: 'rgba(24, 38, 79, 0.1)',
        borderColor: 'rgba(24, 38, 79, 1)',
        borderWidth: 1,
        stack: 'combined',
        fill: true,
        pointRadius: 1,
        order: 1
      }, {
        type: 'line',
        label: 'Measure',
        data: data,
        backgroundColor: 'rgba(59, 247, 203, 0.5)',
        borderColor: 'rgb(24, 38, 79)',
        borderWidth: 1,
        fill: true,
        pointBackgroundColor: 'rgba(0, 0, 255, 0.2)',
        order: 2
      }, {
        type: 'line',
        label: 'Lower Threshold',
        data: lowerThreshold,
        backgroundColor: 'rgba(24, 38, 79, 0.1)',
        borderColor: 'rgba(24, 38, 79, 1)',
        borderWidth: 1,
        stack: 'combined',
        fill: true,
        pointRadius: 1,
        order: 1
      }
      ]
    }
    this.sensoresChart.options.scales.x.min = this.labels[0] - 1;
    this.sensoresChart.options.scales.x.max = this.labels[this.labels.length - 1] + 1;
    this.sensoresChart.update();
  }

  changeSensorsFilterTime(n: number) {
    this.sensorsFilterTime = n;
    this.sensorData = [];
    this.setSensorData();

    // Si el timestamp no ha cambiado a custom o si y no son indefinidos
    if (n != 6 || (this.startCustomTime != undefined && this.endCustomTime != undefined)) {
      // GET de las presencias
      this.getSensorData();
    } else {
      this.sensorData = undefined;
    }
  }

  refreshData() {
    if (this.interval == undefined || this.interval < 1) {
      this.changeIntervalInput(this.intervalDefault);
    } else if(this.interval > this.intervalMax) {
      this.changeIntervalInput(this.intervalMax);
    }
    if (!this.checkDisabledCustom()) {
      this.changeSensorsFilterTime(this.sensorsFilterTime);
    }
  }

  changeIntervalInputWhenChange(input) {
    if (input < 0) {
      this.changeIntervalInput(this.intervalDefault);
    } else if (input > this.intervalMax) {
      this.changeIntervalInput(this.intervalMax);
    }
  }


  changeIntervalInput(input) {
    this.interval = undefined;
    this.changeDetectorRef.detectChanges();
    this.interval = input;
  }

  /*
    Comprueba si los inputs de los timestamps customs
   */
  checkDisabledCustom() {
    return this.sensorsFilterTime == 6 && (this.startCustomTime == undefined || this.endCustomTime == undefined ||
      (new Date(this.startCustomTime).getTime() >= new Date(this.endCustomTime).getTime()) ||
      (new Date(this.endCustomTime).getTime() - new Date(this.startCustomTime).getTime()) > 86400000 * 366 * 2);
  }

  changeSelectSensor(sensor: sensor) {
    this.selectedSensor = sensor;

    // Si el timestamp no ha cambiado a custom o si y no son indefinidos
    if (this.sensorsFilterTime != 6 || (this.startCustomTime != undefined && this.endCustomTime != undefined)) {
      // GET de las presencias
      this.getSensorData();
    } else {
      this.sensorData = undefined;
    }
  }

  checkSelectedSensor(sensor) {
    return this.selectedSensor == sensor;
  }

  sensorsChart() {
    this.sensoresChart = new Chart('sensorsChart', {
      type: 'scatter',
      data: {
        labels: [],
        datasets: [{
          label: 'Upper Threshold',
          data: [],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined',
          fill: true,
        }, {
          label: 'Measure',
          data: [],
          backgroundColor: 'rgba(24, 38, 79, 0.25)',
          borderColor: 'rgba(24, 38, 79, 1)',
          borderWidth: 1,
          stack: 'combined',
          fill: true,
        }, {
            label: 'Lower Threshold',
            data: [],
            backgroundColor: 'rgba(24, 38, 79, 0.25)',
            borderColor: 'rgba(24, 38, 79, 1)',
            borderWidth: 1,
            stack: 'combined',
          fill: true,
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        layout: {
          padding: 0,
        },
        plugins: {
          tooltip: {
            usePointStyle: true,

            callbacks: {
              label: function(context) {
                return context.dataset.label + ": " + context.formattedValue
              },
              title: function(context) {
                return this.convertTimestampToLabel(+context[0].label.split('.').join(""));
              }.bind(this)
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true
          },
          x: {
            ticks: {
              callback: function(value, index, ticks) {
                return this.convertTimestampToLabel(+value);
              }.bind(this)
            }
          }
        }
      }
    });
  }

  measureToData(sensorData: sensorDataChart) {
    let mA = (sensorData.measure * 16 / 255) + 4
    return (((sensorData.equivalencia20mA - sensorData.equivalencia4mA) / 16)
      * (mA - 4) + sensorData.equivalencia4mA);
  }

  toIndicators() {
    this.navigation.toIndicators();
  }

  toLocations() {
    this.navigation.toLocations();
  }

}
